import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_TRAINING_TYPES, 
    ADD_NEW_TRAINING_TYPE, 
    UPDATE_TRAINING_TYPE, 
    DELETE_TRAINING_TYPE 
} from "./actionTypes";

import {
    getTrainingTypesSuccess,
    getTrainingTypesFail,
    addTrainingTypeSuccess,
    addTrainingTypeFail,
    updateTrainingTypeSuccess,
    updateTrainingTypeFail,
    deleteTrainingTypeSuccess,
    deleteTrainingTypeFail,
   
} from "./actions"

import {
    getTrainingTypes,
    addNewTrainingType,
    updateTrainingType,
    deleteTrainingType,
   
} from "helpers/training-types/training_types_backend_helper";
import { toast } from "react-toastify";

function* fetchTrainingTypes() {
    try {
        const response = yield call(getTrainingTypes)
        yield put(getTrainingTypesSuccess(response))
    } catch (error) {
        yield put(getTrainingTypesFail(error))
    }
}

function* onAddNewTrainingType({ payload }) {
    try {

        
        const response = yield call(addNewTrainingType, payload)

        console.log("RESPONSE:", response);
        yield put(addTrainingTypeSuccess(response.trainingType))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addTrainingTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateTrainingType({ payload: data }) {
    try {
        const response = yield call(updateTrainingType, data)
        yield put(updateTrainingTypeSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateTrainingTypeFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateTrainingType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateTrainingType, payload)
        yield put(updateTrainingTypeSuccess(response.TrainingType))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateTrainingTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteTrainingType({ payload: data }) {

    try {
        const response = yield call(deleteTrainingType, data)
        yield put(deleteTrainingTypeSuccess(response.trainingTypeId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteTrainingTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* trainingTypeSaga() {
    yield takeEvery(GET_TRAINING_TYPES, fetchTrainingTypes)
    yield takeEvery(ADD_NEW_TRAINING_TYPE, onAddNewTrainingType)
    yield takeEvery(UPDATE_TRAINING_TYPE, onUpdateTrainingType)
    yield takeEvery(DELETE_TRAINING_TYPE, onDeleteTrainingType)
}

export default trainingTypeSaga;